import {
  LEAD_RESOURCE,
  CUSTOMER_RESOURCE,
  CONSULTANT_RESOURCE,
  CAMPAIGN,
  READ_ACTION,
  LEAD_CUSTOMER,
  CREATE_ACTION,
  APPOINTMENT,
  MANAGE_ACTION,
  OPPORTUNITY_MAP,
  PERFORMANCE_EVOLUTION,
  TRANSFER_LEAD,
  PENDING_INTERVIEWS,
  TRANSFER_CUSTOMER,
  LEAD_CUSTOMER_MENU,
  CUSTOMER_RESOURCE_MENU,
  APPOINTMENT_MENU,
  REQUEST_SPECIALIST_MENU
} from "@/constants/resources";

export default [
  {
    title: "Gestão de clientes",
    icon: "none",
    children: [
      {
        title: "Leads clientes",
        route: "leads-customers-list",
        icon: "UserPlusIcon",
        resource: LEAD_CUSTOMER_MENU,
        action: READ_ACTION,
      },
      {
        title: "Transferir leads",
        route: "leads-transfer",
        icon: "RepeatIcon",
        resource: TRANSFER_LEAD,
        action: MANAGE_ACTION,
      },
      {
        title: "Clientes",
        route: "customers-list",
        icon: "UserIcon",
        resource: CUSTOMER_RESOURCE_MENU,
        action: READ_ACTION,
      },
      {
        title: "Solicitar especialista",
        route: "customers-request-specialist",
        icon: "UserCheckIcon",
        resource: REQUEST_SPECIALIST_MENU,
        action: READ_ACTION,
      },
      {
        title: "Transferir clientes",
        route: "customers-transfer",
        icon: "RefreshCwIcon",
        resource: TRANSFER_CUSTOMER,
        action: MANAGE_ACTION,
      },
      {
        title: "Compromissos",
        route: "appointments",
        icon: "CalendarIcon",
        resource: APPOINTMENT_MENU,
        action: READ_ACTION,
      },
      {
        title: "Captação de leads",
        route: "lead-capture",
        icon: "ShoppingBagIcon",
        resource: CAMPAIGN,
        action: READ_ACTION,
      },
      {
        title: "Mapa de oportunidades",
        route: "opportunity-map-data-studio",
        icon: "MapIcon",
        resource: OPPORTUNITY_MAP,
        action: READ_ACTION,
      },
      {
        title: "EFs sem EP",
        route: "pending-interviews-data-studio",
        icon: "InfoIcon",
        resource: PENDING_INTERVIEWS,
        action: READ_ACTION,
      },
    ],
  },
];
